import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { RootState, useAppDispatch } from "../../../../redux/store";
import { retrieveEventCategory } from "../../../../redux/slice/events/event-category.slice";
import { EventCategoryType } from "../../../../models/events/event-category.model"

const EventLocationComponent = () => {
  const dispatch = useAppDispatch();

  const eventCategoryData = useSelector((state: RootState) => state.eventCategory.data);
  const [data, setData] = useState([] as EventCategoryType[])
  const [isApiLoaded, setIsApiLoaded] = useState(false);

  useEffect(() => {
    dispatch(retrieveEventCategory()).then(() => {
      setIsApiLoaded(true);
    });
  }, [dispatch]);

  useEffect(() => {
    if (isApiLoaded && eventCategoryData.result) {
      setData(eventCategoryData.result)

      setIsApiLoaded(false);
    }
  }, [isApiLoaded, eventCategoryData]);

  return (
    <section className="page-section-off brand-texture-off">
      <div className="container">
        <h2 className="text-center">Upcoming {eventCategoryData?.categoryName }</h2>
        <div className="row">
          <div className="col-xs-12">
            {data.length > 0 && <WidgetEvents data={data}/>}
          </div>
        </div>
      </div>
    </section>
  );
};

const WidgetEvents = (props: { data: EventCategoryType[] }) => {
  const { data } = props;
  return (
    <div className="widget events events-tabs">
      <div className="tabs tabs-responsive">
        <Tabs data={data} />
      </div>
    </div>
  );
};

const Tabs = (props: { data: EventCategoryType[] }) => {
  const { data } = props;
  return (
    <div className="responsive-tabs-container accordion-xs accordion-sm">
      <div className="tab-content">
        <div role="tabpanel" className="tab-pane active">
          <TabPane data={data} />
        </div>
      </div>
    </div>
  );
};

const TabPane = (props: { data: EventCategoryType[] }) => {
  const { data } = props;
  return (
    <>
      <ul className="list-events-tabs slick-on-mobile">
        <WidgetEventsList data={data} />
      </ul>
      <footer className="list-footer">
        <a href="/events?etype=meetings__chapterevents" className="more">
          See All Chapter Events
        </a>
      </footer>
    </>
  );
};

const WidgetEventsList = (props: { data: EventCategoryType[] }) => {
  const { data } = props;
  return (
    <>
      {data.map((item, index) => {
        return (index < 4 ) ? (<li key={index}>
          <WidgetEventsListItem item={item} index={index} />
        </li>) : null;
      })}
    </>
  );
};

const WidgetEventsListItem = (props: { item: EventCategoryType; index: number }) => {
  const { item, index } = props;
  return (
    <div className="item">
      <div className="item-content">
        <div className="product-img text-center"><img alt={item.eventName} src={item.imageUrl} /></div>
        <h5 className="title-off">
          <a id={"EventsFocusedEvent_ctl" + index.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "_lnkEventTitle"} className="link-title" href={`/events/${item.nodeName}`}>
            {item.eventName}
          </a>
        </h5>
        <div className="meta">
          <span className="meta-item date">{item.startDateTime}</span>
          {
            (item.city || item.state || item.country) ? ( 
              <span className="meta-item location">
                {item.city && `${item.city}`}
                {item.state && `, ${item.state}`}
                {item.country && `, ${item.country}`}
                </span>
            ) : ''
          }
          
        </div>
      </div>
      <div className="item-footer">
        <a
          id={"EventsFocusedEvent_ctl" + index.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "_lnkEventRegister"}
          className="btn btn-default"
          href={item.registrationUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Register
        </a>
      </div>
    </div>
  );
};

export default EventLocationComponent